module.exports = __webpack_public_path__ + "media/首页视频2.362e3474.mp4";